// import React from "react";
// import { Card, CardContent, Typography } from "@mui/material";
// import { Line } from "react-chartjs-2";
// import { ChartOptions, LineControllerChartOptions } from 'chart.js';

// interface LineChartCardProps {
//   title: string;
//   subtitle: string;
//   dark?: boolean;
// }

// const LineChartCard: React.FC<LineChartCardProps> = ({ title, subtitle, dark }) => {
//   const data = {
//     labels: ["Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"],
//     datasets: [
//       {
//         label: title,
//         data: [100, 200, 150, 300, 400, 50, 500, 900, 350, 450, 700, 800],
//         borderColor: dark ? "#fff" : "#4caf50",
//         backgroundColor: "transparent",
//       },
//     ],
//   };

//   const options: ChartOptions = {
//     plugins: {
//       legend: {
//         display: false,
//       },
//     },
//     scales: {
//       y: {
//         type: 'linear',
//         beginAtZero: true,
//       },
//       x: {
//         type: 'category',
//         ticks: {
//           display: true,
//         },
//       },
//     },
//   };
  

//   return (
//     <Card style={{ backgroundColor: dark ? "#333" : "#fff", color: dark ? "#fff" : "#000" }}>
//       <CardContent>
//         <Typography variant="h6" sx={{ fontWeight: "bold" }}>{title}</Typography>
//         <Typography variant="body2">{subtitle}</Typography>
//         <Line data={data} options={options as LineControllerChartOptions} />
//       </CardContent>
//     </Card>
//   );
// };

// export default LineChartCard;

import React, { useEffect, useState } from "react";
import { Card, CardContent, Typography } from "@mui/material";
import { Line } from "react-chartjs-2";
import { getMonthlySoldQty } from "../../../Services/DashboardService"; // Import service
import { dark } from "@mui/material/styles/createPalette";

interface LineChartCardProps {
  orgId: string; // Accept orgId as a prop from parent
}

const LineChartCard: React.FC<LineChartCardProps> = ({ orgId }) => {
  const [salesData, setSalesData] = useState<number[]>(Array(12).fill(0));

  useEffect(() => {
    const fetchData = async () => {
      if (!orgId) return; // Prevent API call if orgId is missing

      try {
        const response = await getMonthlySoldQty(orgId);
        if (response?.success) {
          setSalesData(response.monthlySales);
        }
      } catch (error) {
        console.error("Error fetching sales data:", error);
      }
    };

    fetchData();
  }, [orgId]); // Re-fetch if orgId changes

  const chartData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    datasets: [
      {
        label: "Items Sold",
        data: salesData,
        borderColor: "#4caf50",
        backgroundColor: "transparent",
      },
    ],
  };

  return (
    <Card sx={{ borderRadius: 1, padding: 2.9 }}>
      <CardContent>
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>Monthly Sold Items</Typography>
        <Line data={chartData} />
      </CardContent>
    </Card>
  );
};

export default LineChartCard;
